/**
 * Module commun bdc
 * @module app.bdc.files
 */
define([
    'angular',
    'modules/bdc/files/controllers/filesCtrl',
    'modules/bdc/files/factories/filesService',
    'modules/bdc/files/factories/filesProvider'
], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function bdcFilesRouter($routeProvider) {
        $routeProvider.when('/bdc/files/', {
            templateUrl: 'bdc/files/partials/files.html',
            controller: 'FilesCtrl',
            controllerAs: 'filesCtrl',
            params: {
                menuTitle: 'Document'
            }
        });
    }

    bdcFilesRouter.$inject = ['$routeProvider'];

    angular
        .module('app.bdc.files', [
            'app.bdc.files.filesCtrl',
            'app.bdc.files.filesService',
            'app.bdc.files.filesProvider'
        ])
        .config(bdcFilesRouter);
});
